import React from "react";

const faqs = [
  {
    question: "Is Vibely free to use?",
    answer:
      "Yes, the core experience is free. Upgrade for premium filters and boosts.",
  },
  {
    question: "How does matching work?",
    answer:
      "We recommend people based on your preferences and shared interests.",
  },
  {
    question: "Can I report someone?",
    answer:
      "Absolutely. You can block and report users directly from any profile.",
  },
  {
    question: "Is my data private?",
    answer:
      "Your data is encrypted and never shared with third parties without your consent.",
  },
];

function SupportSection() {
  return (
    <section id="support" className="section-tint py-16 sm:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.3em] text-indigo-500 font-semibold">
            Support
          </p>
          <h2 className="heading-primary text-3xl sm:text-4xl font-bold text-gray-900 mt-3">
            We’re here to help
          </h2>
          <p className="text-lg text-subtle mt-4 max-w-2xl mx-auto">
            Find quick answers to common questions. Our team is always
            available.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          {faqs.map((faq) => (
            <article
              key={faq.question}
              className="card-hover rounded-2xl border border-gray-200 bg-white shadow-sm p-6"
            >
              <h3 className="text-lg font-semibold text-gray-900">
                {faq.question}
              </h3>
              <p className="text-gray-600 mt-3 leading-relaxed">{faq.answer}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SupportSection;
